/**
 * Baked into the JS bundle at build time.
 * Keep in sync with public/app-version.json "web" and NmServer-main/app-version.json "web"
 * on every web deploy so the update prompt can detect stale Safari/PWA caches.
 */
export const LOCAL_WEB_VERSION = '2.0.5';
